<template>
  <div class="content_bg">
    <div class="logo">
      <div class="l_xt"></div>
      <div class="l_bt"></div>
    </div>
    <div class="dh">
      <div class="dh_name">
        <div class="dh_bt">电商直播</div>
        <div class="dh_bt">电商大数据</div>
        <div class="dh_bt">电商产品</div>
      </div>
      <div class="titleRightImg">
          <router-link :to="{path:'/'}"><img src="../assets/img/xfksh/sy.png" class="return" /></router-link>
          <img src="../assets/img/xfksh/fh.png" class="return" @click="clickReturn" />
        </div>
    </div>
    <div class="sbh">
      <div class="sbh_bg">
        <div class="sxt">
          <div class="sxt_bg"></div>
          <div class="sxt_bt">1号</div>
        </div>
        <div class="sxt">
          <div class="sxt_bg"></div>
          <div class="sxt_bt">2号</div>
        </div>
      </div>
      <div class="sbh_dbg"></div>
    </div>
    <div class="middle_sxt" id="vd">
      <div class="m_sxt">
        <vue3VideoPlay
          width="100%"
          height="100%"
          :src="options.src"
          :type="options.type"
          :autoPlay="true"
          :control="false"
          :controlBtns="false"
        />
      </div>
    </div>
    <div class="right_bg">
      <div class="r_top">
        <div class="t_t_n">
          <span class="r_jt"></span>
          <h6 class="r_bt">位置信息</h6>
        </div>
        <div class="sbdz">
          <span class="sbdz_tb"></span>
          <span class="sbdz_name">设备地址:</span>
          <span class="sbdz_name_add">驻马店市上蔡县xxxx</span>
        </div>
        <div class="sbdz1">
          <span class="sbdz_tb"></span>
          <span class="sbdz_name">设备安装日期:</span>
          <span class="sbdz_name_add">2024.xx.xx</span>
        </div>
        <div class="sbdz2">
          <span class="sbdz_tb"></span>
          <span class="sbdz_name">最后上线时间:</span>
          <span class="sbdz_name_add">2024.xx.xx</span>
        </div>
      </div>

      <div class="r_middle">
        <div class="t_t_n">
          <span class="r_jt"></span>
          <h6 class="r_bt">云台控制</h6>
        </div>
        <div class="kzq_bg"></div>
        <div class="kzq_kg"></div>
        <div class="kzq_an">
          <div class="a_n">放大</div>
          <div class="a_n">缩小</div>
          <div class="a_n">自动控制</div>
        </div>
      </div>

      <div class="r_bottom">
        <div class="t_t_n">
          <span class="r_jt"></span>
          <h6 class="r_bt">设备监测</h6>
        </div>
        <div class="r_bzt">
          <rightPie />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from 'vue-router'
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";

import rightPie from "../components/xfksh/rightPie.vue";

// import Left1Line from "../components/cangchu/left1Line";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      currentTime: "",
      options: {
        src: require("@/assets/video/zhibo.mp4"), //视频源
        type: 'video/mp4', //视频类型
      },
    });

    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
    return {
      ...toRefs(state),
      clickReturn
    };
  },
  components: {
    rightPie,
  },
};
</script>

<style lang="less" scoped>
#vd .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
.content_bg {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: url("../assets/img/xfksh/bj1.png") no-repeat top center;
  background-size: 100% 100%;

  position: relative;

  .logo {
    width: 320px;
    height: 48px;
    display: flex;
    flex-flow: row wrap;
    position: absolute;
    top: 30px;
    left: 47px;
    .l_xt {
      width: 24px;
      height: 35px;
      background: url("../assets/img/xfksh/sxt.png") no-repeat top center;
      background-size: 100% 100%;
    }
    .l_bt {
      width: 240px;
      height: 46px;
      background: url("../assets/img/xfksh/bt.png") no-repeat top center;
      background-size: 100% 100%;
      margin-left: 10px;
    }
  }
  .dh {
    width: 75%;
    height: 45px;
    position: absolute;
    right: 0;
    top: 31px;
    background: url("../assets/img/xfksh/hx.png") no-repeat top center;
    background-size: 100% 100%;
    display: flex;
    justify-content:space-between;
    .titleRightImg{
        margin-right: 40px;
        .return{
          width: 69px;
          height: 23px;
          margin-right: 15px;
          cursor: pointer;
          position: relative;
          z-index: 999;
          margin-top: -5px;
        }
      }

    .dh_name {
      width: 600px;
      height: 45px;
      margin-top: 10px;
      // border: 1px solid #fff;
      display: flex;
      flex-flow: row wrap;
      .dh_bt {
        height: 100%;
        width: 200px;
        font-size: 15px;
        font-weight: 700;
        color: #fff;
        cursor: pointer;
        justify-content: center;
        display: flex;
        align-items: center; /* 垂直居中 */
      }
      .dh_bt:hover {
        height: 100%;
        width: 200px;
        font-size: 15px;
        color: #1db0b4;
        cursor: pointer;

        justify-content: center;
        display: flex;
        align-items: center; /* 垂直居中 */
        background: url("../assets/img/xfksh/xz.png") no-repeat;
        background-size: 55% 30%;
        background-position: 10px center; /* 上移10像素，水平居中 */
        background-position: center 50%; /* 垂直居中，下移30% */
      }
    }
  }
  .sbh {
    width: 57px;
    height: 500px;
    position: absolute;
    left: 47px;
    bottom: 57px;
    .sbh_bg {
      width: 57px;
      height: 446px;
      background: url("../assets/img/xfksh/jx.png") no-repeat top center;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;

      justify-content: flex-end;
      .sxt {
        width: 100%;
        height: 60px;

        .sxt_bg {
          width: 20px;
          height: 25px;
          background: url("../assets/img/xfksh/sb.png") no-repeat top center;
          background-size: 100% 100%;
          margin-left: 18.5px;
        }
        .sxt_bt {
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 13px;
          text-align: center;
          color: #fff;
        }
      }
    }
    .sbh_dbg {
      width: 44px;
      height: 44px;
      background: url("../assets/img/xfksh/sl.png") no-repeat top center;
      background-size: 100% 100%;
      margin-left: 6.5px;
      margin-top: 9px;
    }
  }
  .middle_sxt {
    width: 64%;
    height: 82%;
    position: absolute;
    // border: 1px solid #fff;
    top: 100px;
    left: 12%;
    background: url("../assets/img/xfksh/k.png") no-repeat top center;
    background-size: 100% 100%;
    .m_sxt {
      width: 80%;
      height: 80%;
      left: 10%;
      top: 10%;
      position: relative;
    }
  }
  .right_bg {
    width: 385px;
    height: 80%;
    position: absolute;
    top: 134px;
    right: 50px;
    background: url("../assets/img/xfksh/jx.png") no-repeat top center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    .r_top {
      width: 100%;
      height: 188px;
      // border: #1db0b4 1px solid;
      position: relative;
      .t_t_n {
        width: 100%;
        height: 40px;
        position: relative;
        .r_jt {
          display: block;
          width: 22px;
          height: 27px;
          position: absolute;
          background: url("../assets/img/xfksh/jt.png") no-repeat top center;
          background-size: 100% 100%;
          top: 36.5%;
          left: 4%;
        }
        .r_bt {
          font-size: 16px;
          width: 90%;
          height: 35px;
          line-height: 35px;
          text-align: left;
          top: 10px;
          color: #fff;
          position: absolute;
          left: 10%;
        }
        .r_bt::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px; /* 下划线的高度 */
          background-image: linear-gradient(
            to right,
            #2a748a,
            #1b4d5e,
            #071925
          ); /* 这里设置你的渐变颜色 */
        }
      }
      .sbdz {
        width: 100%;
        height: 40px;
        // border: #fff 1px solid;
        margin-top: 4%;
        display: flex;
        flex-flow: row wrap;
        span {
          display: block;
          text-align: left;
        }
        .sbdz_tb {
          width: 16px;
          height: 21px;
          background: url("../assets/img/xfksh/sb.png") no-repeat top center;
          background-size: 100% 100%;
          margin-top: 2%;
          margin-left: 9%;
          // display: block;
        }
        .sbdz_name {
          // width: 100px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #18dfe0;
          margin-left: 2%;
          // display: block;
        }
        .sbdz_name_add {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #fff;
          margin-left: 2%;
          // display: block;
        }
      }
      .sbdz1 {
        width: 100%;
        height: 40px;
        // border: #fff 1px solid;
        margin-top: 0%;
        display: flex;
        flex-flow: row wrap;
        span {
          display: block;
          text-align: left;
        }
        .sbdz_tb {
          width: 16px;
          height: 16px;
          background: url("../assets/img/xfksh/rq.png") no-repeat top center;
          background-size: 100% 100%;
          margin-top: 3%;
          margin-left: 9%;
          // display: block;
        }
        .sbdz_name {
          // width: 100px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #18dfe0;
          margin-left: 2%;
          // display: block;
        }
        .sbdz_name_add {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #fff;
          margin-left: 2%;
          // display: block;
        }
      }
      .sbdz2 {
        width: 100%;
        height: 40px;
        // border: #fff 1px solid;
        margin-top: 0%;
        display: flex;
        flex-flow: row wrap;
        span {
          display: block;
          text-align: left;
        }
        .sbdz_tb {
          width: 15px;
          height: 15px;
          background: url("../assets/img/xfksh/sj.png") no-repeat top center;
          background-size: 100% 100%;
          margin-top: 3%;
          margin-left: 9%;
          // display: block;
        }
        .sbdz_name {
          // width: 100px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #18dfe0;
          margin-left: 2%;
          // display: block;
        }
        .sbdz_name_add {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #fff;
          margin-left: 2%;
          // display: block;
        }
      }
    }

    .r_middle {
      width: 100%;
      height: 300px;
      position: relative;
      // border: #fff 1px solid;
      .t_t_n {
        width: 100%;
        height: 40px;
        position: relative;
        .r_jt {
          display: block;
          width: 22px;
          height: 27px;
          position: absolute;
          background: url("../assets/img/xfksh/jt.png") no-repeat top center;
          background-size: 100% 100%;
          top: 36.5%;
          left: 4%;
        }
        .r_bt {
          font-size: 16px;
          width: 90%;
          height: 35px;
          line-height: 35px;
          text-align: left;
          top: 10px;
          color: #fff;
          position: absolute;
          left: 10%;
        }
        .r_bt::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px; /* 下划线的高度 */
          background-image: linear-gradient(
            to right,
            #2a748a,
            #1b4d5e,
            #071925
          ); /* 这里设置你的渐变颜色 */
        }
      }

      .kzq_bg {
        width: 214px;
        height: 202px;
        background: url("../assets/img/xfksh/hxdc.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 50px;
        left: 80px;
        animation: guangying 3s linear infinite;
      }
      .kzq_kg {
        width: 100px;
        height: 100px;
        background: url("../assets/img/xfksh/yt.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 102px;
        left: 138px;
      }
      .kzq_an {
        z-index: 1000;
        width: 100%;
        height: 30px;
        display: flex;
        flex-flow: row wrap;
        position: absolute;
        top: 260px;
        left: 33px;
        font-size: 14px;
        .a_n {
          width: 70px;
          height: 30px;
          margin: 0 17px;
          color: #21e8da;
          text-align: center;
          line-height: 26px;
          border: 2px solid #21e8da;
        }
        .a_n:hover {
          cursor: pointer;
        }
      }
    }
    .r_bottom {
      width: 100%;
      margin-top: 15px;
      // border: #fff 1px solid;
      flex: 1;
      position: relative;
      .t_t_n {
        width: 100%;
        height: 40px;
        position: relative;
        .r_jt {
          display: block;
          width: 22px;
          height: 27px;
          position: absolute;
          background: url("../assets/img/xfksh/jt.png") no-repeat top center;
          background-size: 100% 100%;
          top: 36.5%;
          left: 4%;
        }
        .r_bt {
          font-size: 16px;
          width: 90%;
          height: 35px;
          line-height: 35px;
          text-align: left;
          top: 10px;
          color: #fff;
          position: absolute;
          left: 10%;
        }
        .r_bt::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px; /* 下划线的高度 */
          background-image: linear-gradient(
            to right,
            #2a748a,
            #1b4d5e,
            #071925
          ); /* 这里设置你的渐变颜色 */
        }
      }
      .r_bzt {
        width: 100%;
        height: 75%;
        // border: #18dfe0 1px solid;
        position: relative;
        top: 5%;
      }
    }
  }
}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
</style>
